/**
 * The words of benefits' second pass (#43): the insurer, the travel agent and the dependent as
 * parties. Kept beside the catalogue, as the hubs' and views' words are, and spread into it.
 */
export const HR_BENEFITS_EN = {
    // A dependent is a person on the register; the family link stays in benefits.
    'change.field.policy.insurer_party_id': 'Insurer on the register',
    // The travel policy: the class each grade travels, and the route-cost catalogue.
    'value.status.scheduled': 'From a later day',
    // A cashed ticket paid by payroll; an entitlement ended on purpose.
    'value.end_reason.employment_ended': 'The employment ended',
    'value.end_reason.contract_changed': 'The contract no longer gives it',
    'value.end_reason.entered_in_error': 'Recorded by mistake',
    'value.status.lapsed': 'Lapsed',
};
export const HR_BENEFITS_AR = {
    'change.field.policy.insurer_party_id': 'شركة التأمين في السجلّ',
    'value.status.scheduled': 'من يوم لاحق',
    'value.end_reason.employment_ended': 'انتهت الخدمة',
    'value.end_reason.contract_changed': 'لم يعد العقد يمنحه',
    'value.end_reason.entered_in_error': 'سُجّل خطأً',
    'value.status.lapsed': 'سقطت',
};
//# sourceMappingURL=i18n-hr-benefits.js.map